import APIService from '@/services/APIService.js';

export default {
  getById(id) {
    return APIService.apiCall().get(`/perdasAic/getById/${id}`);
  },
  getAll(includeExpiredRecords) {
    return APIService.apiCall().get(`/perdasAic/getAll/${includeExpiredRecords}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/perdasAic/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/perdasAic/executar/${id}`);
  },
  salvar(postData, id) {
    return APIService.apiCall().post(`/perdasAic/salvar/${id}`, JSON.stringify(postData));
  },
  duplicar(id) {
    return APIService.apiCall().get(`/perdasAic/duplicar/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/perdasAic/baixar/${id}`, {
      responseType: 'blob',
      ...config
    });
  }
};
